import React from 'react'; 
import { Button, Icon } from 'semantic-ui-react';
import { SearchBar } from 'dyl-components';
import '../index.scss';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Toolbar = ({ search, onSearchSubmit, cancelFunction, onChangeSearch, onOpenModal, isReadingDestinationGroups }) => {
    return (
        <div className='DestinationGroupsToolbar'>
            <div style={{flex: 1}}>
                <SearchBar
                    isSearching={isReadingDestinationGroups}
                    search={search}
                    searchFcn={onSearchSubmit}
                    cancelFcn={cancelFunction}
                    placeholder='Search by group name'
                    addClassNames='DestinationGroups__search'
                    onChange={onChangeSearch}
                    bottomError
                />
            </div>
            <div>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_ADD}>
                    <Button className='DestinationGroupsToolbar__button' onClick={onOpenModal}>
                        <Icon name='plus' /> Destination Group
                    </Button>
                </RestrictedView>
            </div>
        </div>
    )
}

export default Toolbar;
